import { useTranslation } from 'react-i18next';
import Language from '@/features/pos-personalization/components/icons/Language';

const LanguageOptionLabel = () => {
	const { t } = useTranslation();

	return (
		<div className='flex items-center gap-2 w-36'>
			<div className='text-icon-tertiary flex items-center justify-center'>
				<Language
					size={16}
					color='currentColor'
				/>
			</div>
			<span>{t('topbar.language')}</span>
		</div>
	);
};

export default LanguageOptionLabel;
